import React, { useEffect } from "react";
import Box from "@mui/material/Box";
import Header from "../../../common/header/Header";
import Breadcrumb from "../../../common/header/Breadcrumb";
import ImportSettings from "../../../components/Import/ImportSettings";

const Import = () => {
  useEffect(() => {
      window.scrollTo(0, 0);
    }, []);
  return (
    <>    
      <Box className="page-background">
       <Header/>
       <Breadcrumb/>
         <ImportSettings/>
      </Box>
    </>
  )
}

export default Import